var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dis-fle ali-cen jus-end"},[_c('el-pagination',_vm._b({attrs:{"current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total,"layout":"prev, pager, next"},on:{"current-change":_vm.onCurrentChange}},'el-pagination',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }